// ANNI — Lieferzeit-Hinweis: tauscht den Text beim Variantenwechsel.
// Hört auf Horizons "variant:update" (siehe events.js). Die Map
// VariantID → Text liegt als JSON im Element (siehe Snippet).
class AnniDeliveryTime extends HTMLElement {
  connectedCallback() {
    try {
      this.map = JSON.parse(this.querySelector('script[ref="map"]')?.textContent || '{}');
    } catch {
      this.map = {};
    }
    this.textEl = this.querySelector('[ref="text"]');

    this.onVariantUpdate = (event) => {
      const { resource, data } = event.detail || {};
      if (!resource?.id) return;
      // Nur reagieren, wenn das Event zum eigenen Produkt gehört
      if (data?.productId && data.productId !== this.dataset.productId) return;

      const text = this.map[String(resource.id)];
      if (text) {
        if (this.textEl) this.textEl.textContent = text;
        this.removeAttribute('hidden');
      } else {
        this.setAttribute('hidden', '');
      }
    };

    document.addEventListener('variant:update', this.onVariantUpdate);
  }

  disconnectedCallback() {
    document.removeEventListener('variant:update', this.onVariantUpdate);
  }
}

if (!customElements.get('anni-delivery-time')) {
  customElements.define('anni-delivery-time', AnniDeliveryTime);
}
